var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"padlet-logo block",attrs:{"href":_vm.homepageUrl,"aria-label":_vm.__('Go to Padlet Homepage')}},[_c('img',{staticClass:"w-full",attrs:{"src":_vm.logo,"alt":_vm.__('Padlet Logo')}})])}
var staticRenderFns = []

export { render, staticRenderFns }